import { useEffect, useState, useRef } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import api from '../api';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    if (!token) {
      setStatus('error');
      setMessage('Verification token not found');
      return;
    }

    api.get(`/auth/verify-email?token=${token}`)
      .then(({ data }) => {
        setStatus('success');
        setMessage(data.message);
      })
      .catch((err) => {
        setStatus('error');
        setMessage(err.response?.data?.error || 'Error verifying email');
      });
  }, [token]);

  return (
    <div className="auth-page">
      <div className="auth-form" style={{ textAlign: 'center' }}>
        {status === 'loading' && <p style={{ color: '#bbb' }}>Verifying your email...</p>}
        {status === 'success' && (
          <>
            <h2 style={{ color: '#5B8C7A' }}>Email verified</h2>
            <p style={{ color: '#bbb', fontSize: 15, marginTop: 12 }}>{message}</p>
            <Link to="/login" className="btn btn-primary" style={{ display: 'inline-block', marginTop: 24 }}>
              Log In
            </Link>
          </>
        )}
        {status === 'error' && (
          <>
            <h2 style={{ color: '#dc2626' }}>Error</h2>
            <p style={{ color: '#bbb', fontSize: 15, marginTop: 12 }}>{message}</p>
            <Link to="/login" className="btn btn-outline" style={{ display: 'inline-block', marginTop: 24 }}>
              Go to login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
